import loadNWApiSDK from '@nerdwallet/nw-api-sdk';
import createMarketplaceSdk from '@nerdwallet/nw-api-sdk/marketplace';
import appConfig from '@nerdwallet/app-config';

const apiSdkConfig = {
  clientID: appConfig.CLIENT_ID,
  cookieDomain: appConfig.COOKIE_DOMAIN,
};

const NWApiSDK = loadNWApiSDK(apiSdkConfig);

export const marketplaceSdk = createMarketplaceSdk({
  ServiceSDK: NWApiSDK.ServiceSDK,
  clientID: appConfig.CLIENT_ID,
  marketplaceBaseUrl: appConfig.API.BASE_URLS.MARKETPLACE,
});

export default NWApiSDK;
